import React, { useContext } from 'react'
import { Locale } from 'contentful'
import kebabCase from 'lodash.kebabcase'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import CurrentLocaleContext from 'marketing-site/src/components/context/CurrentLocaleContext'
import { IHeaderNavigationFin as IContentfulHeaderNavigationFin } from 'marketing-site/@types/generated/contentful'
import { IProps as IHeaderNavigation } from 'marketing-site/src/fin/library/components/HeaderNavigation'
import { HeaderNavigation } from 'marketing-site/src/fin/library/components/HeaderNavigation'
import { transformMutinyCtasContainer } from 'marketing-site/src/transformers/components/ContentfulMutinyCtasContainer'
import { transformSigninLink as transformSignInLink } from 'marketing-site/src/transformers/components/ContentfulHeaderNavigation'
import { Entry } from 'contentful'

export const ContentfulHeaderNavigation = (
  headerNavigation: IContentfulHeaderNavigationFin,
): React.ReactElement => {
  const currentLocale = useContext(CurrentLocaleContext)
  return (
    <EntryMarker entry={headerNavigation}>
      {() => <HeaderNavigation {...transformHeaderNavigation(headerNavigation, currentLocale)} />}
    </EntryMarker>
  )
}

export function isHeaderNavigationFin(entry: Entry<any>): entry is IContentfulHeaderNavigationFin {
  return entry.sys.contentType?.sys.id === 'headerNavigationFin'
}

const transformHeaderNavigation = (
  { fields }: IContentfulHeaderNavigationFin,
  locale: Locale,
): IHeaderNavigation => {
  return {
    ...fields,
    contentType:
      fields.contentType && (kebabCase(fields.contentType) as IHeaderNavigation['contentType']),
    theme: fields.theme && (kebabCase(fields.theme) as IHeaderNavigation['theme']),
    signInLink: fields.signInLink && transformSignInLink(fields.signInLink, locale),
    mutinyCtaContainer:
      fields.mutinyCtasContainer && transformMutinyCtasContainer(fields.mutinyCtasContainer),
  }
}
